import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'emptyDash' })
export class EmptyDashPipe implements PipeTransform {
  transform( value: any ) {
    if (value === null || value === '' || value === ' ' || typeof value === 'undefined') {
      return '-';
    }
    return value;
  }
}
